module.exports = __webpack_public_path__ + "images/Download_hover.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Download_hover.png
// module id = 385
// module chunks = 0 1